export const ADMINISTRATOR = 'Administrator';
export const USER = 'User';
export const SUPPORT = 'Support';
export const MANAGER = 'Manager';
